var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ReportTemplate',{attrs:{"loading":!_vm.initialized,"title":"Room Movement Report","permission":_vm.PERMISSION_CODES.CMS_VIEW_REPORT_INVENTORY_TRANSFER,"filters":_vm.filters,"columns":_vm.columns,"fetchRoute":"/reports/room-movements","reportTypeCode":_vm.REPORT_MASTER_CODES.INVENTORY_TRANSACTION}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }